(() => {
  if (window.kbsCorporateGiftingLoaded) return;
  window.kbsCorporateGiftingLoaded = true;

  // Remember where a visitor came from (ad campaign, click id, landing page) for 30 days, so an enquiry can be tied to the ad.
  const SOURCE_KEY = 'kbsGiftSource';
  const SOURCE_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid'];

  function rememberSource() {
    try {
      const params = new URLSearchParams(window.location.search);
      const fresh = SOURCE_PARAMS.some(name => params.get(name));
      const stored = JSON.parse(window.localStorage.getItem(SOURCE_KEY) || 'null');
      const expired = !stored || Date.now() - stored.at > 30 * 24 * 3600 * 1000;
      if (!fresh && !expired) return;
      if (!fresh && stored && !expired) return;
      const record = { at: Date.now(), landing_url: window.location.href.slice(0, 500), referrer: (document.referrer || '').slice(0, 500) };
      SOURCE_PARAMS.forEach(name => { if (params.get(name)) record[name] = params.get(name).slice(0, 250); });
      window.localStorage.setItem(SOURCE_KEY, JSON.stringify(record));
    } catch (error) { /* storage can be blocked; the enquiry still works without a source */ }
  }

  function storedSource() {
    try {
      const stored = JSON.parse(window.localStorage.getItem(SOURCE_KEY) || 'null');
      if (!stored) return {};
      const copy = Object.assign({}, stored);
      delete copy.at;
      return copy;
    } catch (error) { return {}; }
  }

  rememberSource();

  // The store's Google tag runs inside Shopify's sandbox, so the page has no gtag of its own: load one here (gifting pages only, no page-view hit).
  function ensureGoogleTag() {
    if (typeof window.gtag === 'function') return;
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=AW-766417488';
    document.head.appendChild(script);
    window.gtag('js', new Date());
    window.gtag('config', 'AW-766417488', { send_page_view: false });
  }

  // Tell Google (tag on the site) and Tag Manager when a visitor sends an enquiry or starts the advance payment.
  function trackLead(kind, details) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: 'kbs_gifting_' + kind }, details || {}));
      ensureGoogleTag();
      window.gtag('event', kind === 'advance_started' ? 'begin_checkout' : 'generate_lead', Object.assign({ currency: 'INR', lead_type: kind }, details || {}));
      // Google Ads conversion "Gifting enquiry" (account tag AW-766417488, created 16 Oct 2026).
      if (kind === 'enquiry') window.gtag('event', 'conversion', { send_to: 'AW-766417488/faG4CI2Ymp8dENC0uu0C' });
    } catch (error) { /* tracking must never break the form */ }
  }

  function field(form, name) {
    const input = form.querySelector(`[name="contact[${name}]"]`);
    return input ? input.value.trim() : '';
  }

  function sendToKbs(form, endpoint) {
    const button = form.querySelector('button[type="submit"]');
    const message = form.querySelector('[data-gift-form-message]') || (() => {
      const p = document.createElement('p');
      p.setAttribute('role', 'alert');
      p.className = 'gift-small';
      p.dataset.giftFormMessage = '';
      form.insertBefore(p, form.firstChild);
      return p;
    })();
    const payload = {
      company: field(form, 'Company'), name: field(form, 'name'), email: field(form, 'email'), phone: field(form, 'phone'),
      quantity: Number(field(form, 'Quantity')), budget_from: Number(field(form, 'Budget per gift from')), budget_to: Number(field(form, 'Budget per gift to')),
      delivery_city: field(form, 'Delivery destination'), requirements: field(form, 'Requirements'),
      product_title: form.dataset.giftProductTitle || '', variant_id: String(form.dataset.giftVariant || ''),
      website: (form.querySelector('[name="website"]') || {}).value || ''
    };
    Object.assign(payload, storedSource());
    const date = field(form, 'Required delivery date');
    if (date) payload.delivery_date = date;
    if (form.dataset.giftProductUrl) payload.product_url = window.location.origin + form.dataset.giftProductUrl;
    if (button) button.disabled = true;
    fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
      .then(response => response.json().catch(() => ({})).then(data => ({ status: response.status, data })))
      .then(result => {
        if (result.status === 200 && result.data.ok) {
          trackLead('enquiry', { product: form.dataset.giftProductTitle || '', quantity: Number(field(form, 'Quantity')) || undefined });
          const done = document.createElement('p');
          done.className = 'gift-success';
          done.setAttribute('role', 'status');
          done.textContent = form.dataset.giftSuccess || 'Thank you. Your enquiry has been sent.';
          form.replaceWith(done);
          return;
        }
        if (result.status === 422) {
          const first = result.data.errors ? Object.values(result.data.errors)[0] : null;
          message.textContent = (first && first[0]) || form.dataset.giftFallbackError || '';
          if (button) button.disabled = false;
          return;
        }
        throw new Error('unavailable');
      })
      .catch(() => {
        // Our server did not answer: fall back to Shopify's contact form so the enquiry is not lost.
        form.dataset.giftFallback = 'true';
        if (button) button.disabled = false;
        form.submit();
      });
  }

  function money(value) {
    try { return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 2 }).format(value); }
    catch (error) { return 'Rs. ' + value.toFixed(2); }
  }

  function initAdvance(box) {
    if (box.dataset.giftReady) return;
    box.dataset.giftReady = 'true';
    try { if (new URLSearchParams(window.location.search).get('kbs_advance_preview')) box.hidden = false; } catch (error) { /* preview is optional */ }
    const form = box.querySelector('form');
    const summary = box.querySelector('[data-advance-summary]');
    const errorBox = box.querySelector('[data-advance-error]');
    const submit = box.querySelector('[data-advance-submit]');
    const pricing = document.querySelector('[data-gift-product] [data-gift-pricing]');
    const quantityInput = document.querySelector('[data-gift-product] [data-gift-quantity]');
    const percent = Number(box.dataset.advancePercent) || 10;
    const gst = Number(box.dataset.gstPercent) || 18;

    function amounts() {
      const unit = Number(pricing && pricing.dataset.priceCents) / 100;
      const quantity = Number(quantityInput && quantityInput.value);
      const minimum = Number(pricing && pricing.dataset.moq) || 1;
      if (!(unit > 0) || !Number.isSafeInteger(quantity) || quantity < minimum) return null;
      const subtotal = Math.round(unit * quantity * 100) / 100;
      const tax = Math.round(subtotal * gst) / 100;
      const total = Math.round((subtotal + tax) * 100) / 100;
      const advance = Math.round(total * percent) / 100;
      return { quantity, subtotal, tax, total, advance, balance: Math.round((total - advance) * 100) / 100 };
    }

    function refresh() {
      const a = amounts();
      if (!a) { summary.textContent = 'Enter a quantity at or above the minimum order above to see the advance.'; submit.disabled = true; return; }
      submit.disabled = false;
      summary.textContent = a.quantity + ' units: ' + money(a.subtotal) + ' + GST ' + money(a.tax) + ' = ' + money(a.total) + '. Pay ' + percent + '% advance now: ' + money(a.advance) + '. Balance ' + money(a.balance) + ' before dispatch. Freight is confirmed after purchase.';
    }
    quantityInput && quantityInput.addEventListener('input', refresh);
    box.addEventListener('toggle', refresh);
    refresh();

    form.addEventListener('submit', event => {
      event.preventDefault();
      errorBox.hidden = true;
      const a = amounts();
      if (!a || !form.reportValidity()) return;
      const data = new FormData(form);
      const src = storedSource();
      const payload = {
        shopify_product_id: box.dataset.productId, product_title: box.dataset.productTitle, quantity: a.quantity,
        company: data.get('company'), name: data.get('name'), email: data.get('email'), phone: data.get('phone'),
        gstin: (data.get('gstin') || '').toString().toUpperCase() || null, address: data.get('address'), city: data.get('city'),
        state: data.get('state'), pincode: data.get('pincode'), refund_accepted: form.querySelector('[name="refund_accepted"]').checked,
        website: data.get('website') || '', source: [src.utm_source, src.utm_medium, src.utm_campaign].filter(Boolean).join(' / ') || null
      };
      submit.disabled = true;
      fetch(box.dataset.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
        .then(response => response.json().catch(() => ({})).then(body => ({ status: response.status, body })))
        .then(result => {
          if (result.status === 200 && result.body.ok && result.body.invoice_url) { trackLead('advance_started', { value: result.body.advance, product: box.dataset.productTitle || '', quantity: a.quantity }); window.location.assign(result.body.invoice_url); return; }
          const first = result.body.errors ? Object.values(result.body.errors)[0] : null;
          errorBox.textContent = (first && first[0]) || result.body.message || 'Something went wrong. Please send a bulk quote request instead.';
          errorBox.hidden = false;
          submit.disabled = false;
        })
        .catch(() => {
          errorBox.textContent = 'We could not reach the server. Please try again or send a bulk quote request.';
          errorBox.hidden = false;
          submit.disabled = false;
        });
    });
  }

  function initialise(scope = document) {
    scope.querySelectorAll('[data-gift-advance]').forEach(initAdvance);
    scope.querySelectorAll('[data-gift-product]').forEach(product => {
      if (product.dataset.giftInitialised) return;
      product.dataset.giftInitialised = 'true';
      const pricing = product.querySelector('[data-gift-pricing]');
      const quantity = product.querySelector('[data-gift-quantity]');
      const output = product.querySelector('[data-gift-total]');
      const error = product.querySelector('[data-gift-error]');
      const selector = product.querySelector('[data-gift-variant]');
      const quoteLink = product.querySelector('[data-gift-quote-link]');
      const unitPrice = Number(pricing?.dataset.priceCents);
      const minimum = Number(pricing?.dataset.moq);
      const increment = Number(pricing?.dataset.increment);
      let formatter;
      try {
        formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency: pricing?.dataset.currency
        });
      } catch {
        formatter = null;
      }

      function update() {
        if (!quantity || !output) return;
        const amount = Number(quantity.value);
        const valid = Number.isSafeInteger(amount) && amount >= minimum && (amount - minimum) % increment === 0;
        quantity.setCustomValidity(valid ? '' : error?.textContent.trim() || 'Invalid quantity');
        if (error) error.hidden = valid;
        output.textContent = valid && formatter && Number.isSafeInteger(amount * unitPrice)
          ? formatter.format(amount * unitPrice / 100) : '';
        if (quoteLink) quoteLink.setAttribute('aria-disabled', String(!valid));
        document.querySelectorAll('[data-gift-enquiry]').forEach(form => {
          const field = form.querySelector('[data-gift-form-quantity]');
          if (field && valid) field.value = amount;
        });
      }

      quantity?.addEventListener('input', update);
      quoteLink?.addEventListener('click', event => {
        if (quantity && !quantity.reportValidity()) event.preventDefault();
      });
      selector?.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', selector.value);
        window.location.assign(url.toString());
      });
      update();
    });

    scope.querySelectorAll('[data-gift-enquiry]').forEach(form => {
      if (form.dataset.giftInitialised) return;
      form.dataset.giftInitialised = 'true';
      const body = form.querySelector('[data-gift-body]');
      const field = form.querySelector('[data-gift-form-quantity]');
      const source = document.querySelector('[data-gift-product] [data-gift-pricing]');
      if (source && field && Number(source.dataset.moq) > 0) {
        field.min = source.dataset.moq;
        field.step = source.dataset.increment;
        field.value = source.dataset.moq;
      }
      const initialBody = body?.value || '';
      form.addEventListener('submit', event => {
        const from = form.querySelector('[data-gift-budget-from]');
        const to = form.querySelector('[data-gift-budget-to]');
        if (from && to) {
          to.setCustomValidity(Number(to.value) < Number(from.value) ? (to.dataset.giftRangeError || '') : '');
          if (!to.reportValidity()) { event.preventDefault(); return; }
        }
        if (field && !field.reportValidity()) {
          event.preventDefault();
          return;
        }
        if (body) {
          const lines = [...form.querySelectorAll('[data-gift-summary]')].map(input =>
            `${input.dataset.giftSummary}: ${input.value.trim()}`
          );
          body.value = [initialBody, ...lines].filter(Boolean).join('\n');
        }
        const endpoint = form.dataset.giftEndpoint;
        if (endpoint && window.fetch && !form.dataset.giftFallback) {
          event.preventDefault();
          sendToKbs(form, endpoint);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise());
  } else initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
